const wait = (milliseconds: number) => {
  return new Promise((resolve: any) => {
    setTimeout(() => {
      resolve();
    }, milliseconds);
  });
};

export default wait;
